import { Badge } from "@/components/ui/v2/badge";

type WithMarginBadgeProps = {
  name: string;
  includeMargin: boolean;
};

const WithMarginBadge = ({ name, includeMargin }: WithMarginBadgeProps) => {
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <span>{name}</span>
      {includeMargin && <Badge variant="neutral">21%</Badge>}
    </div>
  );
};

export default WithMarginBadge;
